// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"activate_wrapper__1TRmu"};